import * as React from 'react';

import {Basic} from './Basic.story';
import {Actions} from './Actions.story';
import {TitlesSubtitles} from './TitlesSubtitles.story';
import {Disabled} from './Disabled.story';
import {Media} from './Media.story';

const basic = {
  rendered: <Basic />,
  source: `<Accordion>
  <AccordionItem title="Apples">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
  <AccordionItem title="Bananas">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
  <AccordionItem title="Peaches" subtitle="A subtitle can be provided">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
</Accordion>`,
};

const actions = {
  rendered: <Actions />,
  source: `const titles = ['Example using a link', 'Example using a button', 'Multiple buttons are cool too'];
const actionExamples = [
  <Link onPress={() => null}>Edit</Link>,
  <Button onPress={() => null}>Configure</Button>,
  <ButtonGroup>
    <Button onPress={() => null}>Action 1</Button>
    <Button onPress={() => null}>Action 2</Button>
  </ButtonGroup>,
];

<Accordion>
  {[0, 1, 2].map(i => (
    <AccordionItem
      title={titles[i]}
      subtitle={i > 2 && 'An optional subtitle can be provided.'}
      actions={actionExamples[i]}
      key={i}
    >
      <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
    </AccordionItem>
  ))}
</Accordion>`,
};

const titlesSubtitles = {
  rendered: <TitlesSubtitles />,
  source: `<Accordion>
  <AccordionItem title="Apples">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
  <AccordionItem title="Bananas">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
  <AccordionItem title="Oranges">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
  <AccordionItem title="Peaches" subtitle="A subtitle can be provided">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
</Accordion>`,
};

const disabled = {
  rendered: <Disabled />,
  source: `<Accordion>
  <AccordionItem
    title="Oranges"
    actions={<Button disabled onPress={() => null}>Edit</Button>}
  >
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
</Accordion>`,
};

const media = {
  rendered: <Media />,
  source: `<Accordion>
  <AccordionItem
    media={<Img src="https://example.com/bank.svg" />}
    title="ACH credit transfer"
    subtitle="ACH Credit Transfer enables US customers to pay by sending funds directly to a US bank account."
  >
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
  <AccordionItem
    title="Cards"
    subtitle="Accept Visa, Mastercard, American Express, Discover, Diners Club, and JCB payments from customers worldwide."
  >
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
  <AccordionItem title="Apple Pay" subtitle="Manage Apple Pay domains and certificates.">
    <Box css={{padding: 'xlarge'}}>Accordion contents</Box>
  </AccordionItem>
</Accordion>`,
};

export const AccordionExamples = {
  basic,
  actions,
  titlesSubtitles,
  disabled,
  media,
};
